module.exports = __webpack_public_path__ + "media/application/images/icons/ui-icons_777620_256x240-191c7becdb6c18103e32414c9c4ad37c.png";